export var ModelEventAction;
(function (ModelEventAction) {
    ModelEventAction["UPDATE"] = "update";
    ModelEventAction["MANUAL_UPDATE"] = "manual-update";
    ModelEventAction["UPDATE_INDEX"] = "update-index";
    ModelEventAction["DELETE"] = "delete";
    ModelEventAction["META"] = "meta";
})(ModelEventAction || (ModelEventAction = {}));
export var ManualUpdateTypes;
(function (ManualUpdateTypes) {
    ManualUpdateTypes["INIT"] = "init";
    ManualUpdateTypes["REGENERATE_STATE"] = "regenerateState";
    ManualUpdateTypes["REGENERATE_INDEXES"] = "regenerateIndexes";
    ManualUpdateTypes["REGENERATE_METADATA"] = "regenerateMetadata";
})(ManualUpdateTypes || (ManualUpdateTypes = {}));
export var UpdateStrategy;
(function (UpdateStrategy) {
    UpdateStrategy["REPLACE"] = "replace";
    UpdateStrategy["MERGE"] = "merge";
})(UpdateStrategy || (UpdateStrategy = {}));
export const generateTrackIdentifier = (modelName, action) => `${modelName}:${action}`;
export const getActionFromTrackIdentifier = (trackIdentifier) => trackIdentifier.split(":")[1];
export const getModelNameFromTrackIdentifier = (trackIdentifier) => trackIdentifier.split(":")[0];
export var ModelSubscribeEventBatchSize;
(function (ModelSubscribeEventBatchSize) {
    ModelSubscribeEventBatchSize[ModelSubscribeEventBatchSize["default"] = 1] = "default";
    ModelSubscribeEventBatchSize["auto"] = "auto";
})(ModelSubscribeEventBatchSize || (ModelSubscribeEventBatchSize = {}));
export var ModelSubscriberEventFirstContentSendSize;
(function (ModelSubscriberEventFirstContentSendSize) {
    ModelSubscriberEventFirstContentSendSize[ModelSubscriberEventFirstContentSendSize["default"] = 1] = "default";
    ModelSubscriberEventFirstContentSendSize["auto"] = "auto";
})(ModelSubscriberEventFirstContentSendSize || (ModelSubscriberEventFirstContentSendSize = {}));
export var ModelSubscribeEventQueWaitTime;
(function (ModelSubscribeEventQueWaitTime) {
    ModelSubscribeEventQueWaitTime[ModelSubscribeEventQueWaitTime["default"] = 100] = "default";
})(ModelSubscribeEventQueWaitTime || (ModelSubscribeEventQueWaitTime = {}));
export var ModelSubscribeEventKeepAlivePeriod;
(function (ModelSubscribeEventKeepAlivePeriod) {
    ModelSubscribeEventKeepAlivePeriod[ModelSubscribeEventKeepAlivePeriod["default"] = 5000] = "default";
})(ModelSubscribeEventKeepAlivePeriod || (ModelSubscribeEventKeepAlivePeriod = {}));
export var ModelSubscribeEventKeepAliveCheckPendingPeriod;
(function (ModelSubscribeEventKeepAliveCheckPendingPeriod) {
    ModelSubscribeEventKeepAliveCheckPendingPeriod[ModelSubscribeEventKeepAliveCheckPendingPeriod["default"] = 5000] = "default";
})(ModelSubscribeEventKeepAliveCheckPendingPeriod || (ModelSubscribeEventKeepAliveCheckPendingPeriod = {}));
//# sourceMappingURL=types.js.map